import React from 'react';
import { Link } from 'react-router-dom';

declare const __APP_VERSION__: string | undefined;

const APP_VERSION = typeof __APP_VERSION__ !== 'undefined' ? __APP_VERSION__ : '0.0.0';

export const Footer: React.FC = () => {
  return (
    <footer className="border-t border-border bg-muted/30 py-4 px-4 mt-auto">
      <div className="mx-auto w-full max-w-[1600px] flex flex-col sm:flex-row items-center justify-center gap-1 sm:gap-2 font-body text-body-sm text-muted-foreground">
        <span>Desenvolvido por Corps Teknologi</span>
        <span className="hidden sm:inline" aria-hidden>·</span>
        <Link to="/politica-de-privacidade" className="hover:underline">
          Política de Privacidade
        </Link>
        <span className="hidden sm:inline" aria-hidden>·</span>
        <Link to="/zehmotoca" className="hover:underline">
          Zeh Motoca
        </Link>
        <span className="hidden sm:inline" aria-hidden>·</span>
        <Link to="/cliente/login" className="hover:underline">
          Área do cliente
        </Link>
        <span className="hidden sm:inline" aria-hidden>·</span>
        <span>Versão {APP_VERSION}</span>
      </div>
    </footer>
  );
};
